import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';

import { EnvelopeList } from '../../interfaces/sign.model';
import { environment } from '@unico-people/ongoing-dashboard/enviroment';
import * as fromStore from '@unico-people/shared/dashboard/data-access-store';

import {
  ResponseEmployee,
  ResponseReasonsBlock,
  ResponseServicesByEmployee,
  ResponseSearchEmployee,
  ListEmployeesData,
  ListEmployeesRescuesData,
  UpdateEmployeeData
} from '../../interfaces/requests.model';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Injectable({ providedIn: 'root' })
export class EmployeesService {
  private url: string = environment.url;
  acc = SessionStorage.getItem('currentAccount');

  constructor(private http: HttpClient, private store: Store<any>) {
    this.store.pipe(select(fromStore.getOrganizationState)).subscribe(res => {
      this.acc = res?.currentAccount?.uid;
    });
  }

  /**
   * List employees
   */
  listEmployees(params?: ListEmployeesData): Observable<any> {
    const { order, active, page, pageSize } = params;

    return this.http.get<any>(`${this.url}/employees/?page=${page}&pageSize=${pageSize}&active=${active}&order=${order}`, {
      observe: 'response'
    });
  }

  /**
   * Search employees rescues
   */
  searchEmployeesRescues(query: string, params: ListEmployeesRescuesData): Observable<any> {
    const { order, page, pageSize } = params;
    return this.http.get<any>(
      `${this.url}/employees/orders/search?query=${query}&page=${page}&pageSize=${pageSize}&order=${order}&active=true`);
  }

  /**
   * Get employee
   */
  getEmployee(id: string): Observable<ResponseEmployee> {
    return this.http.get<ResponseEmployee>(`${this.url}/employees/${id}`);
  }

  /**
   * Delete employee
   */
  deleteEmployee(id: string): Observable<{ resquestId: string }> {
    return this.http.delete<{ resquestId: string }>(`${this.url}/employees/${id}`);
  }

  /**
   * Update employee
   */
  updateEmployee(data: UpdateEmployeeData): Observable<ResponseEmployee> {
    this.acc = SessionStorage.getItem('currentAccount');
    return this.http.patch<ResponseEmployee>(`${this.url}/employees/${data.id}?account=${this.acc}`, data);
  }

  /**
   * Search employee
   */
  searchEmployee(query: string, params?: ListEmployeesData): Observable<ResponseSearchEmployee> {
    this.acc = SessionStorage.getItem('currentAccount');
    const { order, active, page, pageSize, units, roles, departments } = params;
    const data = {
      search: query,
      status: active,
      units: units,
      roles: roles,
      departments: departments,
      account: this.acc,
    };
    return this.http.post<ResponseSearchEmployee>(`${this.url}/employees/search?sortOrder=${order}&page=${page}&pageSize=${pageSize}`, data);
  }

  /**
   * Change Employee Status
   * @param id of employee
   * @param status is value boolean of field active
   */
  changeEmployeeStatus(id: string, status: boolean): Observable<{ requestId: string }> {
    this.acc = SessionStorage.getItem('currentAccount');
    const data = {
      active: status
    };
    return this.http.patch<{ requestId: string }>(`${this.url}/employees/${id}/status?account=${this.acc}`, data);
  }

  /**
   * Change many employee status
   * @param listId is array of id employees
   * @param status is value boolean of field active
   */
  changeManyEmployeeStatus(listId: Array<string>, status: boolean): Observable<{ requestId: string }> {
    const data = {
      employeeIDs: listId,
      active: status
    };
    return this.http.patch<{ requestId: string }>(`${this.url}/employees/statuses`, data);
  }

  /**
   * Get services by employee
   * @param filtersObject is object filters contain a list of unit, role, and department ids
   */
  getEmployeeByFilters(filtersObject: any, status: boolean): Observable<any> {
    const data = {
      status: status,
      ...filtersObject
    };
    return this.http.post<any>(`${this.url}/employees/ids`, data);
  }

  /**
   * Get services by employee
   * @param id of employee
   */
  getEmployeeServices(id: string): Observable<ResponseServicesByEmployee> {
    return this.http.get<ResponseServicesByEmployee>(`${this.url}/services/employees/${id}`);
  }

  /**
   * Get reasons for block employees
   * @returns object array with id and description of reseasons block
   */
  getReasonsBlockEmployee(): Observable<ResponseReasonsBlock> {
    return this.http.get<ResponseReasonsBlock>(`${this.url}/services/reasons`);
  }

  /**
   * Get envelopes by colaborator ID
   */
   getDocumentsEmployee(id: string, page: number): Observable<EnvelopeList> {
    return this.http.get<any>(`${this.url}/employees/${id}/signs?page=${page}`);
  }

  /**
   * Download document by employee and document ID
   */
   downloadDocumentEmployee(employeeId: string, documentId: string): any {
    return this.http.get(`${this.url}/employees/${employeeId}/signs/${documentId}`, {
      responseType: 'blob'
    });
  }
}
